'use strict';

// Semantic UI Stylesheets
require('ta-semantic-ui/semantic/dist/components/segment.css');
require('ta-semantic-ui/semantic/dist/components/container.css');
require('ta-semantic-ui/semantic/dist/components/header.css');
require('ta-semantic-ui/semantic/dist/components/list.css');
require('ta-semantic-ui/semantic/dist/components/icon.css');
require('ta-semantic-ui/semantic/dist/components/grid.css');
require('ta-semantic-ui/semantic/dist/components/label.css');

// D3
import * as timeformat from 'd3-time-format';
import reqwest from 'reqwest';

//region React Imports
import React from 'react';
require('./Electors.css');
//endregion

class Electors extends React.Component {

  constructor(state) {
    super(state);

    // Calculate End Date
    let endDate = new Date(Date.now());
    endDate.setMonth(endDate.getMonth() + 1);

    // Set default values – important to have real values, otherwise components
    // down the line will fail to render.
    this.state = {
      ... state,
      error: 'Daten werden geladen ...',
      lastUpdate: "01.01.2000",
      democratVotes: 0,
      republicanVotes: 0,
      undecidedVotes: 0,
      democratPercentage: 0,
      republicanPercentage: 0,
      undecidedPercentage: 0,
      democratesStyle: {},
      republicansStyle: {},
      undecidedStyle: {},
      majorityValue: 0
    };

  }

  componentDidMount() {


    //region Chart data
    // Load chart data from pollster

    /* So, this is utterly ridiculous. The Pollster API is public, but it
     doesn't support the CORS mechanism (it doesn't provide the
     Access-Control-Allow-Origin: * header). As such, modern browsers will
     complain and not load the data. In order to make it work anyway, I
     have to use JSONP. Fine, why not – but in order to properly work with
     that, I have to load the complete jQuery library. That's 100KB more
     data, just to get that done. So, so very stupid.
     */



    const url = 'http://www.realclearpolitics.com/epolls/json/29_map_historical.js?1473325120799&callback=return_json';

    reqwest(
      {
        url: url,
        type: 'jsonp',
        jsonpCallback: 'callback',
        jsonpCallbackName: 'electorCallback'
      })
      .then((result) => {

        //console.log("######## RESULT ############");
        //console.log(result);
        
        var latestPoll = result['poll']['rcp_avg']['0'];

        var pollDate = latestPoll['date'];
        //console.log("pollDate: "+pollDate);
        var d = new Date(pollDate);
        var day = d.getDate();
        if(day < 10) {
          day = "0"+day;
        }
        var month = d.getMonth()+1;
        if(month < 10) {
          month = "0"+month;
        }
        var year = d.getFullYear();
        pollDate = day+"."+month+"."+year;
        this.setState({lastUpdate: pollDate});

        
        //get elector values
        var totalElectors = 538;
        var majorityValue = Math.round(totalElectors/2);
        if(majorityValue % 2 != 0) {
          majorityValue++;
        }
        //console.log("majorityValue: "+majorityValue);
        this.setState({majorityValue: majorityValue});
        var democratElectorValues = latestPoll['candidate']['0'].value;
        var republicanElectorValues = latestPoll['candidate']['1'].value;
        var undecidedElectorValues = totalElectors - democratElectorValues - republicanElectorValues;
        //console.log("democrat: "+democratElectorValues+" | republican: "+republicanElectorValues+" | undecided: "+undecidedElectorValues);
        this.setState({democratVotes: democratElectorValues});
        this.setState({republicanVotes: republicanElectorValues});
        this.setState({undecidedVotes: undecidedElectorValues});

        //calculate percentages
        var democratPercentageValue = 100/totalElectors*democratElectorValues;
        var republicanPercentageValue = 100/totalElectors*republicanElectorValues;
        var undecidedPercentageValue = 100 - democratPercentageValue - republicanPercentageValue;
        //console.log("democrat: "+democratPercentageValue+"% | republican: "+republicanPercentageValue+"% | undecided: "+undecidedPercentageValue+"%");
        this.setState({democratPercentage: democratPercentageValue});
        this.setState({republicanPercentage: republicanPercentageValue});
        this.setState({undecidedPercentage: undecidedPercentageValue});

        //inline styles
        var democratesStyle = {
          width: democratPercentageValue+"%",
        };
        this.setState({democratesStyle: democratesStyle});
        var republicansStyle = {
          width: republicanPercentageValue+"%",
        };
        this.setState({republicansStyle: republicansStyle});
        var undecidedStyle = {
          width: undecidedPercentageValue+"%",
        };
        this.setState({undecidedStyle: undecidedStyle});

    });
    //endregion
    
  }

  render() {

    return (

      <div className="ui basic vertical infographic">
        <h4 className="ui header">
          Wer bei den Elektoren gemäss Umfragen führt
          <div className="sub header meta">Stand vom {this.state.lastUpdate}
            </div>
        </h4>

        <div className="electorCandidates">
          <div className="label" style={this.state.democratesStyle}>
              <img
                src='//interaktiv.tagesanzeiger.ch/static/2016/us-elections/clinton.png'
                alt='' className='ui tiny inline bordered avatar image'/>
          </div>

           <div className="label spacer" style={this.state.undecidedStyle}></div>

          <div className="label" style={this.state.republicansStyle}>
            <img
              src='//interaktiv.tagesanzeiger.ch/static/2016/us-elections/trump.png'
              alt='' className='ui tiny inline bordered avatar image'/>
          </div>
        </div>

        <div className="electorScale ui white label large">
          <div className="electoralVotes ui blue label large" style={this.state.democratesStyle}><div className="voteCount"><div>{this.state.democratVotes} Stimmen</div></div></div>
          <div className="electoralVotes ui white label large" style={this.state.undecidedStyle}><div className="voteCount"><div>{this.state.undecidedVotes} offen</div></div></div>
          <div className="electoralVotes ui red label large" style={this.state.republicansStyle}><div className="voteCount"><div>{this.state.republicanVotes} Stimmen</div></div></div>
          <div className="middleIndicator">&nbsp;</div>
        </div>
        <div className="majorityNumber content">{this.state.majorityValue} von 538<br />Elektorenstimmen</div>

        <div className="ui secondary vertical very fitted segment">
          <div className="ui small list">
            <div className="item"><i className="info circle icon"/>
              <div className="content">
                <p>Der US-Präsident wird nicht national gewählt, sondern in den Bundesstaaten. Der Sieger in einem Staat erhält alle seine sogenannten Wahlmännerstimmen. Insgesamt sind 538 Stimmen zu vergeben - wer mindestens 270 sammelt, wird US-Präsident. Je grösser die Bevölkerung eines Staates ist, desto mehr Elektoren sind hier zu gewinnen.</p>
                <p>Die Daten stammen von <a
                href="http://www.realclearpolitics.com/epolls/2016/president/2016_elections_electoral_college_map.html"
                target="_blank">Real Clear Politics</a> und basieren auf Umfragen in den einzelnen Staaten.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default Electors;



//helper
function parseDate(input, format) {
  format = format || 'yyyy-mm-dd'; // default format
  var parts = input.match(/(\d+)/g), 
      i = 0, fmt = {};
  // extract date-part indexes from the format
  format.replace(/(yyyy|dd|mm)/g, function(part) { fmt[part] = i++; });

  return new Date(parts[fmt['yyyy']], parts[fmt['mm']]-1, parts[fmt['dd']]);
}



/** WEBPACK FOOTER **
 ** ./src/components/electors/Electors.js
 **/